// extracted by mini-css-extract-plugin
module.exports = {"code":"Code_code__1qPjP","codeBlock":"Code_codeBlock__phmce"};